import React from 'react'
import {
    View,
    StyleSheet,
} from 'react-native';
import { TrackingPieChart } from './tracking-pie-chart';
import TrackingWorkoutTotals from './tracking-workout-totals';
import Theme from '../../theme';
import { defaultScale } from '../../utils/scaling';
const isSmallMobile = window.innerWidth <= 350;

export class TrackingTotalWorkoutTile extends React.Component {

    render() {
        return (
            <View style={styles.container}>
                <TrackingPieChart data={this.props.totals} />
                <View style={styles.totalsContainer}>
                    <TrackingWorkoutTotals  totals={this.props.totals}/>
                </View>
            </View>
        )
    }
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        backgroundColor: Theme.WHITE,
        borderRadius: defaultScale(3),
        width: '100%',
        marginBottom: defaultScale(15),
    },
    totalsContainer: {
        marginLeft: defaultScale(isSmallMobile ? 33 : 40),
        justifyContent: 'center',
        marginTop: defaultScale(-20)
    }
});